<template>
    <div>
        <ContentHeader path-set-type="append"   />
        <div class="content-wrapper" v-loading="loading" >
            <el-row >
                <el-col :span="6" class="content-left">
                <div class="trade-container">
                    <el-card class="trade-nav-panel">
                    <div slot="header" class="clearfix">
                        <span class="panel-header">审批状态</span>
                    </div>
                    <el-menu  :default-active="menuCode"  active-text-color="#000000" text-color="#000000">
                        <el-menu-item
                        v-for="(item) in menuMap"
                        :key="item.key"
                        :index="item.key"
                        @click="clickMenu(item.key)"
                        >
                        <span slot="title">{{item.value}}</span>
                        </el-menu-item>
                    </el-menu>
                    </el-card>
                </div>
                </el-col>
                <el-col :span="18" class="content-right">
                    <div class="search">
                        <el-form :inline="true" :model="searchForm" ref="searchForm" class="searchForm" >
                        <el-form-item class="item" prop="prId">
                            <el-input v-model="searchForm.prId" placeholder="PR编码" size="small"></el-input>
                        </el-form-item>
                        <el-form-item class="item" prop="prName">
                            <el-input v-model="searchForm.prName" placeholder="PR名称" size="small"></el-input>
                        </el-form-item>
                        <el-form-item class="item" prop="activityName">
                            <el-input v-model="searchForm.activityName" placeholder="活动名称" size="small"></el-input>
                        </el-form-item>
                        <el-form-item class="item" prop="selectBu">
                            <el-select v-model="searchForm.selectBu" placeholder="BU" size="small" clearable>
                                <el-option
                                v-for="item in buOptions"
                                :key="item.orgId"
                                :label="item.orgName"
                                :value="item.orgCode">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item class="item" prop="selectBrand">
                            <el-select v-model="searchForm.selectBrand" placeholder="选择品牌" size="small" clearable>
                                <el-option
                                v-for="item in brandOptions"
                                :key="item.brandId"
                                :label="item.brandName"
                                :value="item.abiBrandCode">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item class="item-btn">
                            <el-button type="danger" size="small" @click="queryForm()">搜索</el-button>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="info" size="small" @click="resetForm()">重置</el-button>
                        </el-form-item>
                        </el-form>
                    </div>
                    <div class="card-box"  v-if="cardData.length > 0" >
                        <div class="card is-hover-shadow"  v-for="(item,index) in cardData" :key="index" >
                        <div class="card-left">
                            <div class="left-top">
                                <span>{{item.themeName}}</span>
                            </div>
                            <div class="pr-item-flex">
                              <div style="margin-top:12px;"><span class="font-weight-bold">PR信息：</span>{{getItemInfo(item.gpPrDTOList,'pr')}}</div>
                            </div>
                            <div class="pr-item-flex">
                              <div style="margin-top:12px;"><span class="font-weight-bold">品牌信息：</span>{{ getItemInfo(item.gpPrDTOList,'brand') }}</div>
                            </div>
                            <div class="left-last">
                                <span>活动时间：</span>
                                <span>{{getTime(item.themeStartTime)}}</span>
                                <span>-</span>
                                <span>{{getTime(item.themeEndTime)}}</span>
                            </div>
                        </div>
                        <div class="card-right">
                            <div class="right-top">
                                <span v-if="menuCode == '01'">待审批</span>
                                <span v-if="menuCode == '02'">BU已确认</span>
                            </div>
                            <div class="right-center">
                                <span>BU：</span>
                                <span> {{getName(item.buName)}}</span>
                            </div>
                            <div class="right-btn">
                                <!-- <button class="btn-right"  @click="goDetail(item)">查看详情</button> -->
                                <button v-if="menuCode == '01'" class="btn-right"  @click="goDetail(item)">
                                    <span >去审批</span>
                                </button>
                                <button v-else class="btn-right" style=" color: #cd1231;border: 1px solid #cd1231; background-color: #FFFFFF;"   @click="goDetail(item)">
                                    <span>查看详情</span>
                                </button>

                            </div>
                        </div>
                    </div>
                    </div>
                    <div v-else>
                        <!-- style="height:50vh; line-height:50vh;text-align: center;" -->
                        <!-- {{loadingText}} -->
                        <el-empty description="暂无数据" ></el-empty>
                    </div>
                    <div class="pagination" v-if="cardData.length !== 0">
                        <el-pagination
                        background
                        layout="total, prev, pager, next"
                        :total="searchForm.total"
                        :current-page="searchForm.page"
                        :page-size="searchForm.pageSize"
                        @current-change="handleCurrentChange"
                        />
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import ContentHeader from '@/components/content-header'
    import gameplanApi from '../../api/gameplan'
    export default {
      name: 'quotaChange-approval',
      components: {
        ContentHeader,
      },
      data () {
        return {
            searchForm: {
                prId: '', // PR编码
                prName: '', // PR名称
                activityName: '', // 活动名称
                selectBu: '' , // 选择bu
                selectBrand: '', // 选择品牌
                searchStatus: '',// 查询状态
                page: 1,
                pageSize: 10,
                total:0,
            },
            channelOptions: [], // 渠道下拉菜单
            brandOptions: [], // 品牌下拉菜单
            buOptions: [], // 渠道下拉菜单
            cardData: [],
            activityType:'', // 路由类型信息
            isFinish: false,
            isWait: false,
            isReject: false,
            loading:true,
            loadingText: '',
            menuCode: '',
            menuMap:[
                {key:'01',value:"待审批"},
                {key:'02',value:"BU已确认"}
            ]

        }
      },
      computed: {
        ...mapGetters(['userInfo']),
      },
      watch: {},
      created () {
        this.menuCode = '01'
        this.init()
      },
      mounted () {
      },
      methods: {
        init () {
            this.getSelectBrand()
            this.getSelectBu()
            this.getThemelist()
        },
        clickMenu (code) {
            this.menuCode = code
            this.searchForm.page = 1
            this.getThemelist()
        },
        getChannel(themeChannels, sign) {
            if (themeChannels) {
                let arr = themeChannels.map((item) => {return item.themeChannelEnName}).join(sign);
                return arr;
            } else {
                return 'null'
            }
        },
        getTime (timestamp) {
        if (timestamp === 0 || timestamp == null) {
            return ''
        } else {
            var date = new Date(parseInt(timestamp)) // 时间戳为13位的话需要parseInt下
            const Y = date.getFullYear() + '-'
            const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
            const D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
            // const h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
            // const m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
            // const s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
            return Y + M + D
            }
        },
        getThemelist () {
            let params = {
                page: this.searchForm.page,
                pageSize: this.searchForm.pageSize,
                prNumber: this.searchForm.prId,
                prName: this.searchForm.prName,
                themeName: this.searchForm.activityName,
                brandCode: this.searchForm.selectBrand,
                buCode: this.searchForm.selectBu,
                queryQuote: this.menuCode,
            }
            this.loading = true
            gameplanApi.getGamepalnReportquery(params).then(res=>{
                if (res.data.resultCode === '0') {
                    this.loading = false
                    let pageData = res.data.resultData.pageInfo
                    this.searchForm.page = Number(pageData.curPage)
                    // this.searchForm.pageSize = pageData.totalPages
                    this.searchForm.total = Number(pageData.totalCounts)
                    if (res.data.resultData.themeList == null) {
                    this.cardData = []
                    this.loadingText = '空数据'
                    } else {
                        this.cardData = res.data.resultData.themeList
                        this.loadingText = ''
                    }
                } else {
                    this.loading = false
                    console.log('接口error');
                }
            })
        },
        async getSelectChannel () {
            // name=gpThemeChannelMap&type=list或map
            let params = {
                name:'gpThemeChannelMap',
                type:'list'
            }
            let data =  await gameplanApi.getGamepalnChannelquery(params)
            this.channelOptions = data.data.resultData.gpThemeChannelMap
        },
        async getSelectBrand () {
            let data =  await gameplanApi.getGamepalnBrandquery()
            this.brandOptions = data.data.resultData.btmpBrandDTOList
        },
        async getSelectBu () {
            let data =  await gameplanApi.getGamepalnBuquery()
            this.buOptions = data.data.resultData.voList
        },
        getItemInfo(gpPrDTOList,type){
          let brandInfo = []
          let prInfo = []
          if(gpPrDTOList){
            gpPrDTOList.forEach(item=>{
              let data = ''
              if(type==='pr') prInfo.push(item.prNumber+'-'+item.prName)
              else {
                if(item.brandName&&item.subBrandName)  data = item.brandName+'-'+item.subBrandName
                else data = item.brandName||item.subBrandName
                if(brandInfo.indexOf(data)===-1) { 
                  brandInfo.push(data)
                }
              }
            })
          }
          if(type==='pr') return prInfo.join('、')
          else return brandInfo.join('、')
        },
        handleCurrentChange (val) {
          this.searchForm.page = val
          this.getThemelist()
        },
        queryForm (val) {
            this.$refs.searchForm.validate((valid) => {
            if (valid) {
                this.searchForm.page = 1
                this.getThemelist()
            } else {
                return false;
            }
            });
        },
        resetForm () {
            this.$refs.searchForm.resetFields();
            this.searchForm.page = 1
            this.getThemelist()
        },
        // 查看详情
        goDetail (item) {
            this.$router.push({path:'/gameplan/quotaChange-approval-detail',query: {
                'themeId':item.themeId,
                'activityType':this.menuCode,
                // 'themeStatus':item.themeStatus,
                'buCode':item.buCode,
                'buName':item.buName
            }})
        },
        getName(str){
            if(str){
                return str.split('|')[0] || str
            }else return ''
        },
      }
    }
</script>
<style lang="scss" scoped>
    .el-menu-item.is-active {
        // color: #fff;
        border: none;
        font-weight: bold;
        // background-color: rgba(51, 51, 51, 0.2) !important;
    }
    .is-hover-shadow:hover {
    box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.2);
    }
    .trade-nav-panel {
      width: 80%;
    //   min-height: 400px;
      margin: 0 auto;
      background: $base-white;
    //   .el-menu-item:last-child{
    //     border-bottom: 0;
    //   }
      ::v-deep .el-card__header {
        height: 70px;
        line-height: 35px;
      }
      ::v-deep .el-card__body {
        padding: 0;
      }
      .panel-header {
        font-size: 16px;
        font-weight: 700;
        color:#CD1231;
      }
      ::v-deep .el-menu {
        border-right: 0;
      }
      ::v-deep .el-menu-item {
        border-bottom: 1px solid $base-grey5;
      }
      ::v-deep .el-menu-item.is-active {
        color: $base-red;
      }
    }
    .content-wrapper {
      min-height: calc(100vh - 320px) !important;
      font-family: SourceHanSansSC-regular;
      .content-right {
        height: 100%;
        padding: 0 auto;
        box-sizing: border-box;
        a {
          text-decoration: none;
          color: #000;
        }
        .search {
            margin: 0 auto;
            width: 900px;
            .searchForm {
                width: 100%;
                .item {
                    width:120px;
                    ::v-deep .el-input__inner {
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                    }
                }
                .item-btn {
                    margin-left: 30px;
                }
            }
        }
        .card-box {
            .card {
                margin: 0 auto;
                width: 880px;
                display: flex;
                justify-content: flex-start;

                padding:10px 10px;
                background-color: #FFFFFF ;
                border-radius: 8px;
                font-size: 14px;
                margin-bottom: 20px;
                .card-left {
                    text-align: left;
                    color: #101010;
                    width: 80%;
                    .left-top {
                        line-height: 27px;
                        font-family: SourceHanSansSC-medium;
                        font-size: 18px;
                        font-weight: 600;
                        word-wrap: break-word;
                        word-break: normal;
                        word-break: break-all;
                    }
                    .left-second {
                        font-size: 14px;
                        line-height: 20px;
                        margin-top: 5px;
                    }
                    .left-third {
                        font-size: 14px;
                        line-height: 20px;
                        margin-top: 8px;
                        display: flex;
                        justify-content: flex-start;
                        .left-third-left {
                            // width:100px;
                            display: flex;
                            justify-content: flex-start;
                            color: #CD1231;
                            margin-right: 20px;
                            .img {
                                width: 20px;
                                margin-right: 3px;
                                height: 20px;
                            }
                        }
                        .left-third-right {
                            flex: 1;
                            display: flex;
                            justify-content: flex-start;
                            .img {
                                width: 20px;
                                margin-right: 3px;
                                height: 20px;
                            }
                            .text {
                                margin: 0px 3px 0px 3px ;
                                color: #EDB60A;
                            }
                        }
                    }
                    .left-last {
                        font-size: 14px;
                        line-height: 20px;
                        color: #999999 ;
                        margin-top: 8px;
                    }
                }
                .card-right {
                    flex: 1;
                    text-align: right;
                    display:flex;
                    flex-direction:column;
                    justify-content:space-between;
                    .right-top {
                        height: 27px;
                        line-height: 27px;
                        color: #CD1231 ;
                        font-size: 16px;
                        font-weight: 600;
                    }
                    .right-center {
                        //margin-top: -px;
                        height: 20px;
                        line-height: 20px;
                        color:#999999;
                        font-size: 16px;
                    }
                    .right-btn {
                        margin-top: 12px;
                        .btn-right {
                            width: 84px;
                            height: 32px;
                            border-radius: 4px;
                            border: 1px solid #CD1231;
                            background-color: #CD1231;
                            font-size: 14px;
                            color: #FFFFFF;
                            text-align: center;
                            font-family: Microsoft Yahei;
                            cursor: pointer;
                        }
                    }
                }
            }
        }
        .pagination {
            position: relative;
            bottom: 0;
            // left: ;
            text-align: center;
        }
      }
      .content-left {
        padding-right: $content-middle;
      }
    }
.pr-item-flex{
  display:flex;
  flex-wrap:wrap;
}
</style>
